/**
 * Reliable platform detection using Capacitor when available.
 * NEVER detect platform by screen size.
 *
 *   "web"          — regular browser (default)
 *   "ios_native"   — iOS Capacitor shell
 *   "android_native" — reserved for future
 */
export function detectPlatform() {
  const mode = (process.env.REACT_APP_PLATFORM_MODE || "auto").toLowerCase();
  if (mode === "web" || mode === "ios_native" || mode === "android_native") {
    return mode; // manual override
  }
  try {
    const cap = typeof window !== "undefined" ? window.Capacitor : null;
    if (cap && typeof cap.getPlatform === "function") {
      const p = cap.getPlatform();
      if (p === "ios") return "ios_native";
      if (p === "android") return "android_native";
    }
  } catch {}
  return "web";
}

export const isWeb = () => detectPlatform() === "web";
export const isIOSNative = () => detectPlatform() === "ios_native";
export const isAndroidNative = () => detectPlatform() === "android_native";

export const stripeEnabled = () =>
 (process.env.REACT_APP_ENABLE_STRIPE_WEB || "false").toLowerCase() === "true";

export const appleIAPEnabled = () =>
 (process.env.REACT_APP_ENABLE_APPLE_IAP || "false").toLowerCase() === "true";
